<template>
  <BaseModal>
    <div v-if="company" class="w-full">
      <div class="grid grid-cols-2 gap-4">
        <BaseInput
          v-model="company.companyNumber"
          disabled
          label="Företagsnummer"
        />
        <BaseInput v-model="company.name" label="Företagsnamn" />
        <BaseInput v-model="company.displayname" label="Visningsnamn" />
        <BaseInput v-model="company.VAT" label="Organisationsnummer" />
        <div class="col-start-2">
          <div>
            <input
              type="checkbox"
              name="Bokföring"
              v-model="company.moduleAccounting"
              class="mr-2"
            />
            <label for="Bokföring">Bokföring</label>
          </div>
          <div>
            <input
              class="mr-2"
              type="checkbox"
              name="Fortnox"
              v-model="company.moduleFortnox"
            />
            <label for="Fortnox">Fortnox</label>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex flex-row justify-between">
        <button
          @click="sendWelcomeEmail"
          class="btn btn-outline-secondary"
          :disabled="emailSent"
        >
          Skicka inloggningsuppgifter
        </button>
        <div class="flex justify-end">
          <button class="btn btn-default" @click="close">Stäng</button>
          <button class="btn btn-secondary" @click="save">Spara</button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import CreateFortnoxConnection from '@/graphql/CreateFortnoxConnection.gql'
import UpdateCompany from '@/graphql/UpdateCompany.gql'
import BaseModal from '@/components/BaseModal'
import SendWelcomeEmail from '@/graphql/SendWelcomeEmail.gql'
export default {
  data() {
    return {
      company: null,
      loading: false,
      submitLoading: false,
      emailSent: false,
    }
  },
  components: {
    BaseModal,
  },
  methods: {
    close() {
      this.$router.push({
        name: 'companydetails',
        params: { id: this.$route.params.id },
      })
    },
    async save() {
      await this.$apollo.mutate({
        mutation: UpdateCompany,
        variables: {
          data: {
            name: this.company.name,
            VAT: this.company.VAT,
            displayname: this.company.displayname,
            moduleGiveBack: this.company.moduleGiveBack,
            companyType: this.company.companyType,
            moduleSalaries: this.company.moduleSalaries,
            moduleFortnox: this.company.moduleFortnox,
            voadyFortnoxId: this.company.voadyFortnoxId,
            isChurn: this.company.isChurn,
            moduleVoadyBase: this.company.moduleVoadyBase,
            disabledDate: this.company.disabledDate,
            activationDate: this.company.activationDate,
            enabled: this.company.enabled,

            moduleAccounting: this.company.moduleAccounting,
            parentCompany: this.company.parentCompany
              ? this.company.parentCompany.id
              : null,
          },
          id: this.$route.params.subId,
        },
      })
      this.$notify({
        title: 'OK',
        text: 'Information sparad',
      })
    },

    async sendWelcomeEmail() {
      const confirm = window.confirm(
        `Skicka inloggningsuppgifter till förutbestämd e-post?`
      )
      if (!confirm) {
        const response = window.prompt('Skriv in E-post')
        if (response && response.length > 0) {
          await this.$apollo.mutate({
            mutation: SendWelcomeEmail,
            variables: {
              id: this.$route.params.subId,
              email: response,
            },
          })
          this.emailSent = true
        }
      } else {
        await this.$apollo.mutate({
          mutation: SendWelcomeEmail,
          variables: {
            id: this.$route.params.subId,
          },
        })
        this.emailSent = true
      }
    },
  },
  apollo: {
    company: {
      query: require('../../graphql/Company.gql'),
      variables() {
        return {
          id: this.$route.params.subId,
        }
      },
      fetchPolicy: 'no-cache',
      loadingKey: 'loading',
    },
  },
}
</script>
